import { __assign, __awaiter, __generator } from "tslib";
import { simulateClick, getBaseReactDriver } from '../../common/base-driver';
import { delay } from '../../common';
import * as React from 'react';
import { renderAndMountComponent, cleanPopovers } from '@wix/answers-lib';
import { AudioPlayer } from './audio-player.comp';
import { createActionsMenuButtonDriver, createFloaterMenuDriver } from '../../composites/drivers';
import { jsdomReactUniDriver } from '@unidriver/jsdom-react';
export var createAudioPlayerDriver = function (elem) {
    var base = getBaseReactDriver(elem);
    var numberRegex = /[^0-9\.]/g;
    var global = jsdomReactUniDriver(document.body);
    var actionMenu = createFloaterMenuDriver(global);
    return {
        getPlaybackSpeed: function () { return base.find('.play-rate-container .play-rate').getText().replace(numberRegex, ''); },
        changePlaybackSpeed: function () { return __awaiter(void 0, void 0, void 0, function () {
            var playRate;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        cleanPopovers();
                        base.find('.play-rate-container .play-rate').click();
                        return [4 /*yield*/, delay(50)];
                    case 1:
                        _a.sent();
                        playRate = document.querySelectorAll('.play-rate-item')[0];
                        if (playRate) {
                            simulateClick(playRate);
                        }
                        return [2 /*return*/];
                }
            });
        }); },
        openMenu: function () {
            var uniDriver = jsdomReactUniDriver(elem);
            return createActionsMenuButtonDriver(uniDriver.$('.menu-actions'), global).openMenu();
        },
        deleteRecording: function () { return actionMenu.selectByValue('delete'); },
        base: base
    };
};
export var renderAudioPlayerAndReturnDriver = function (props) {
    var elem = renderAndMountComponent(React.createElement(AudioPlayer, __assign({}, props)));
    return createAudioPlayerDriver(elem);
};
//# sourceMappingURL=audio-player.driver.js.map